import { Component } from '@angular/core';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { RouterLink } from '@angular/router';
import { CommonComponent } from '@components/common.component';
import { authenticationActions } from '@redux/authentication.redux';
import { NgIf } from '@angular/common';

@Component({
  selector: 'app-profile',
  standalone: true,
  imports: [BsDropdownModule, RouterLink, NgIf],
  templateUrl: './profile.component.html',
  styleUrl: './profile.component.scss',
})
export class ProfileComponent extends CommonComponent {
  logout() {
    this.store.dispatch(authenticationActions.logout({ communityCode: this.community?.code }));
  }
}
